<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('inventory_receipts.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openInventoryReceiptForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetInventoryReceipts(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="inventory_receipts" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openInventoryReceiptForm(props.item)">
                                <td>{{ props.item.receipt_id }}</td>
                                <td>{{ props.item.purchase_order_id }}</td>
                                <td>{{ props.item.part_id }}</td>
                                <td>{{ props.item.receipt_date }}</td>
                                <td>{{ props.item.received_quantity }}</td>
                                <td>{{ props.item.received_cost }}</td>
                                <td>{{ props.item.vendor }}</td>
                                <td>{{ props.item.created_by }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="inventory_receipts"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="inventory_receipt_dialog">
                <v-card>
                    <v-form ref="form_inventory_receipt">
                        <v-card-title>
                            <span class="headline">{{
                                inventory_receipt.receipt_id ? $t("lang.edit_inventory_receipt") : $t("lang.add_inventory_receipt")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeInventoryReceiptDialog"
                                :dialog-status="inventory_receipt_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="inventory_receipt.receipt_id"
                                            :label="$t('lang.receipt_id')"
                                            :counter="showCounter(inventory_receipt.receipt_id, 'inventory_receipts.receipt_id')"
                                            :rules="ifValid('inventory_receipts.receipt_id')"
                                            v-readonly-click
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="inventory_receipt.purchase_order_id"
                                            :label="$t('lang.purchase_order_id')"
                                            :items="purchase_orders"
                                            item-value="purchase_order_id"
                                            item-text="purchase_order_id"
                                            :rules="ifValid('inventory_receipts.purchase_order_id')"
                                            clearable
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="inventory_receipt.part_id"
                                            :label="$t('lang.part_id')"
                                            :items="fe_part_options"
                                            item-value="part_id"
                                            item-text="part_id"
                                            :rules="ifValid('inventory_receipts.part_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="inventory_receipt.receipt_date"
                                            :label="$t('lang.receipt_date')"
                                            :rules="ifValid('inventory_receipts.receipt_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="inventory_receipt.received_quantity"
                                            :label="$t('lang.quantity')"
                                            :counter="showCounter(inventory_receipt.received_quantity, 'inventory_receipts.received_quantity')"
                                            :rules="ifValid('inventory_receipts.received_quantity')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="inventory_receipt.received_cost"
                                            :label="$t('lang.unit_cost')"
                                            :counter="showCounter(inventory_receipt.received_cost, 'inventory_receipts.received_cost')"
                                            :rules="ifValid('inventory_receipts.received_cost')"
                                        ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="inventory_receipt.vendor_id"
                                            :label="$t('lang.vendor_id')"
                                            :items="vendor_id"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('inventory_receipts.vendor_id')"
                                        ></bc-autocomplete>
                                    </v-flex> -->
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="inventory_receipt.receipt_id" color="error" @mouseup.left="$refs.delete_inventory_receipts.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeInventoryReceiptDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveInventoryReceipts">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_inventory_receipts"
                :heading="$t('lang.delete_inventory_receipt')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteInventoryReceipts(inventory_receipt.receipt_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openInventoryReceiptForm" },
                { title: this.$t("lang.refresh"), action: "dbGetInventoryReceipts", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.receipt_id"), sortable: false, width: "12%" },
                { text: this.$t("lang.purchase_order_id"), sortable: false, width: "12%" },
                { text: this.$t("lang.part_id"), sortable: false, width: "12%" },
                { text: this.$t("lang.receipt_date"), sortable: false, width: "12%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "12%" },
                { text: this.$t("lang.unit_cost"), sortable: false, width: "12%" },
                { text: this.$t("lang.vendor_id"), sortable: false, width: "12%" },
                { text: this.$t("lang.received_by"), sortable: false, width: "12%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            inventory_receipt: {},
            filter: {
                search: "",
            },
            inventory_receipt_dialog: false,
            dbGetInventoryReceipts: _.debounce(this.getInventoryReceipts, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchInventoryReceipts", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.inventory_receipts) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchInventoryReceipts({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.inventory_receipts) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.inventory_receipts.inventory_receipts_filter,
            page: (state) => state.inventory_receipts.page,
            rules_inventory_receipts: (state) => state.inventory_receipts.rules_inventory_receipts,
            inventory_receipt_status_options: (state) => state.settings.inventory_receipt_status_options,
            inventory_receipts: (state) => state.inventory_receipts.inventory_receipts,
            fe_part_options: (state) => state.fe_parts.fe_part_options,
            purchase_orders: (state) => state.purchase_orders.purchase_orders,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchInventoryReceipts", "saveInventoryReceipt", "deleteInventoryReceipt", "fetchFeParts", "fetchPurchaseOrders"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openInventoryReceiptForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_inventory_receipt)
                        item ? this.$refs.form_inventory_receipt.resetValidation() : this.$refs.form_inventory_receipt.reset();

                    this.$nextTick(() => {
                        this.inventory_receipt = item != null ? this.assignObj2(item, this.rules_inventory_receipts) : {};
                        this.fetchPurchaseOrders({ body: { options: 1, with_trashed: this.inventory_receipt.purchase_order_id ? "1" : "0" } });
                        this.inventory_receipt_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "inventory_receipt", params: { id: item.receipt_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_inventory_receipt)
                        item ? this.$refs.form_inventory_receipt.resetValidation() : this.$refs.form_inventory_receipt.reset();
                    this.inventory_receipt_dialog = true;
                } else {
                    this.$router.push({ name: "inventory_receipt" });
                }
            }
        },
        saveInventoryReceipts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_inventory_receipt")) {
                    let body = this.prepForm(this.inventory_receipt, this.rules_inventory_receipts);

                    this.saveInventoryReceipt({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getInventoryReceipts();
                                this.closeInventoryReceiptDialog();
                            } else {
                                this.$router.push({ name: "inventory_receipt", params: { id: data.receipt_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteInventoryReceipts(id = null) {
            this.deleteInventoryReceipt({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getInventoryReceipts();
                    this.closeInventoryReceiptDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeInventoryReceiptDialog() {
            this.inventory_receipt_dialog = false;
            this.$refs.delete_inventory_receipts.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getInventoryReceipts(pg_refresh = false) {
            this.startLoader();

            this.fetchInventoryReceipts({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.inventory_receipt_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            //if (this.fe_part_options.length == 0 || force == true)

            if (this.purchase_orders.length == 0 || force == true)
                await this.fetchPurchaseOrders({ body: { options: 1, with_trashed: this.inventory_receipt.purchase_order_id ? "1" : "0" } });
        },
    },
};
</script>
